import {KColorSchema, SpreadsheetSchema} from "./types";

export class SpreadsheetResultPayload {
  result: any;
  cache_key: SpreadsheetSchema;
  schema_version?: number | undefined;
  result_type: string | undefined;

  constructor(
    result: any,
    cache_key: SpreadsheetSchema,
    result_type: string,
    schema_version?: number | undefined,
  ) {
    this.result = result;
    this.cache_key = cache_key;
    this.schema_version = schema_version;
    this.result_type = result_type;
  }
}

export class KColorResultPayload {
  result: any;
  cache_key: KColorSchema;
  schema_version?: number | undefined;
  result_type: string | undefined;

  constructor(
    result: any,
    cache_key: KColorSchema,
    result_type: string,
    schema_version?: number | undefined,
  ) {
    this.result = result;
    this.cache_key = cache_key;
    this.schema_version = schema_version;
    this.result_type = result_type;
  }
}
